export const Portrait = ({ className = "", eager = false }) => (
  <div className={`relative ${className}`}>
    <div aria-hidden="true" className="absolute -inset-3 rounded-t-[999px] rounded-b-[28px] border border-[#B9A9D8]/60" />
    <img
      src="/portrait-violeta-dubov.jpg"
      alt="Portrait of Violeta Dubov, Registered Social Worker"
      width="900"
      height="1200"
      loading={eager ? "eager" : "lazy"}
      className="relative aspect-[3/4] w-full rounded-t-[999px] rounded-b-[24px] object-cover object-top"
      data-testid="practitioner-portrait"
    />
  </div>
);
